import { Container, Grid, Paper, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import { Routes } from "../routes/Routes";

import HomeWorkIcon from "@mui/icons-material/HomeWork";
import ExtensionIcon from "@mui/icons-material/Extension";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { Colors } from "../theme/colors";
import { useContent } from "../content/useContent";

const classes = {
  center: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    p: 1,
    minHeight: "300px",
    cursor: "pointer",
    transition: "0.1s",
    "&:hover": {
      border: `4px solid ${Colors.primary}`,
    },
  },
};

const Home = () => {
  const navigate = useNavigate();
  const { home } = useContent().pages;
  return (
    <Layout>
      <Container sx={classes.center}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Paper
              sx={classes.paper}
              onClick={() => navigate(Routes.events)}
              elevation={3}
            >
              <CalendarMonthIcon sx={{ fontSize: 50 }} color="primary" />
              <Typography
                variant="h4"
                component="h4"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                {home.events}
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper
              sx={classes.paper}
              onClick={() => navigate(Routes.directories)}
              elevation={3}
            >
              <HomeWorkIcon sx={{ fontSize: 50 }} color="primary" />
              <Typography
                variant="h4"
                component="h4"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                {home.directories}
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper
              sx={classes.paper}
              onClick={() => navigate(Routes.games)}
              elevation={3}
            >
              <ExtensionIcon sx={{ fontSize: 50 }} color="primary" />
              <Typography
                variant="h4"
                component="h4"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                {home.games}
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper
              sx={classes.paper}
              onClick={() => navigate(Routes.tenantCommunityInbox)}
              elevation={3}
            >
              <NotificationsIcon sx={{ fontSize: 50 }} color="primary" />
              <Typography
                variant="h4"
                component="h4"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                {home.tenantCommunityInbox}
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default Home;
